import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

// A bare surface. Each caller adds its own padding and layout — this app never
// used the header/content/footer structure shadcn's card assumes.
export function Card({ className = "", children }: { className?: string; children: ReactNode }) {
  return (
    <section className={cn("rounded-lg border border-border bg-card shadow-card", className)}>
      {children}
    </section>
  );
}
